import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Loading, SharingTables } from '../root/components/common'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { cloneDeep } from 'lodash'
import * as actions from './actions'
import { Table } from '../root/components/common/table'

const useStyles = makeStyles(theme => ({
    wrapper: {
        height: '100%'
    },
    noItemsWrapper: {
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    link: {
        fontWeight: 'bold',
        cursor: 'pointer'
    },
    tableInfo: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%'
    }
}))

function ChooseReports(props){
    const classes = useStyles()
    const dispatch = useDispatch()

    const { isLoading, locale } = useSelector(state => state.main)
    const { reports, selectedReports } = useSelector(state => state.sharing)
    const [checkedInitialReports, setCheckedInitialReports] = useState({})
    const [checkedSelectedReports, setCheckedSelectedReports] = useState({})
    const [reportsMutable, setReportsMutable] = useState(reports ? cloneDeep(reports) : [])
    const [selectedReportsMutable, setSelectedReportsMutable] = useState(cloneDeep(selectedReports))

    const columns = [
        {
            key: 'name',
            label: locale.common.name,
            sortable: true,
            dataType: 'string',
            useCustomRenderer: false
        },
        {
            key: 'serial_number',
            label: locale.sharing.serialNr,
            sortable: true,
            dataType: 'string',
            useCustomRenderer: false
        }
    ]

    const setReportsState = (data) => {
        dispatch(actions.reportsRequestSuccess(data))
        setCheckedInitialReports({})
        setCheckedSelectedReports({})
    }

    const setSelectedReportsState = (data) => {
        dispatch(actions.setSelectedReports(data))
        setCheckedInitialReports({})
        setCheckedSelectedReports({})
    }

    useEffect(() => {
        setReportsMutable(cloneDeep(reports))
        setSelectedReportsMutable(cloneDeep(selectedReports))
    }, [reports, selectedReports])

    return (
        <div className={classes.wrapper}>
            {isLoading &&
                <Loading/>
            }
            {!isLoading &&
                <React.Fragment>
                    {(!reportsMutable || reportsMutable.length === 0) && (!selectedReportsMutable || selectedReportsMutable.length === 0) &&
                        <div className={classes.noItemsWrapper}>
                            <div>
                                {locale.sharing.noReportsToShare}
                            </div>
                        </div>
                    }
                    {((reportsMutable && reportsMutable.length > 0) || selectedReportsMutable && selectedReportsMutable.length > 0) &&
                        <SharingTables
                            leftData={reportsMutable}
                            rightData={selectedReportsMutable}
                            selectedLeftData={checkedInitialReports}
                            selectedRightData={checkedSelectedReports}
                            uniqueKey='id'
                            setLeftData={setReportsState}
                            setRightData={setSelectedReportsState}
                            leftTable={
                                (reportsMutable && reportsMutable.length > 0)
                                ? (
                                    <Table
                                        rows={reportsMutable}
                                        columns={columns}
                                        multiselect
                                        selected={checkedInitialReports}
                                        select={setCheckedInitialReports}
                                    />
                                )
                                : (
                                    <div className={classes.tableInfo}>
                                        {locale.sharing.noReportsLeft}
                                    </div>
                                )
                            }
                            rightTable={
                                (selectedReportsMutable && selectedReportsMutable.length > 0)
                                ? (
                                    <Table
                                        rows={selectedReportsMutable}
                                        columns={columns}
                                        multiselect
                                        selected={checkedSelectedReports}
                                        select={setCheckedSelectedReports}
                                    />
                                )
                                : (
                                    <div className={classes.tableInfo}>
                                        {locale.sharing.noReportsSelected}
                                    </div>
                                )
                            }
                        />
                    }
                </React.Fragment>
            }
        </div>
    )
}

export default withRouter(ChooseReports)
